import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { CustomerWaitingListViewModel } from '../business-entities/customer-waiting-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';

@Injectable({
  providedIn: 'root'
})
export class CustomerWaitinglistService {

  constructor(private dataProvider : DataService) { }

  async getCustomerWaitingList(data):Promise<GenericResponse<Array<CustomerWaitingListViewModel>>>{
    return this.dataProvider.Post<GenericResponse<Array<CustomerWaitingListViewModel>>>(Urls.GetCustomerWaitingList,data).toPromise();
  }

}
